import {t} from '../../../services/localization/localizationService';
import AiAssistantToggle from '../AiAssistantToggle';
import AiAssistantSettingCard from './AiAssistantSettingCard';

// Device icons set their own `dark:` fill, hence the `!`
const AiAssistantSettingToggleTile = ({setting: {titleStrCode, Icon}, isAlone, value, onChange}) => (
    <AiAssistantSettingCard className={isAlone ? 'items-center' : 'flex-col'}>
        <div className='flex flex-1 flex-col items-start'>
            <Icon className='h-8 w-8 shrink-0 [&_path]:!fill-color-romance' />
            <span className='text-14 leading-5 tracking-[0.4px] text-color-romance'>{t(titleStrCode)}</span>
        </div>

        <AiAssistantToggle isActive={value} onClick={onChange} />
    </AiAssistantSettingCard>
);

export default AiAssistantSettingToggleTile;
